export function unique(a: any[]) {
    return Array.from(new Set(a));
}

/**
 * Remove an item from array
 * @param item 
 * @param arr 
 */
export function remove<T>(item: T, arr: T[]) {
    const index = arr.indexOf(item);
    if (index > -1) {
        arr.splice(index, 1);
    }
}
